import { render, staticRenderFns } from "./DeleteStatisticDialog.vue?vue&type=template&id=3f3aefeb&"
import script from "./DeleteStatisticDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteStatisticDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports